import { load as webFontLoader } from 'webfontloader';

const configureWebFontService = () => {
  const loadFonts = () => {
    if (typeof webFontLoader !== 'undefined') {
      webFontLoader({
        google: {
          families: ['Montserrat:300,400,500,700&display=swap']
        }
      });
    }
  };

  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(loadFonts);
  } else {
    setTimeout(loadFonts, 0);
  }
};

export default configureWebFontService;
